export default "__VITE_ASSET__C$BnVXMT__"